(function (app) {
    app.provider("wistiaApi", [function () {
        this.$get = ["portalApiGateway", function (portalApiGateway) {
            var service = {};

            service.getLiveWireAssets = function () {
                return portalApiGateway.get("/WistiaApi/Livewire");
            };

            service.getSocialSecurityResourceAssets = function () {
                return portalApiGateway.get("/WistiaApi/SocialSecurityResources");
            }; 

            service.getDolAssets = function () {
                return portalApiGateway.get("/WistiaApi/Dol");
            };

            //service.getLeadClubAssets = function () {
            //    return portalApiGateway.get("/WistiaApi/LeadClub");
            //};

            service.getLtcTrainingAssets = function () {
                return portalApiGateway.get("/WistiaApi/LtcTraining");
            };

            service.getSalesCoachJdAssets = function () {
                return portalApiGateway.get("/WistiaApi/SalesCoachJd");
            };

            service.getAffinityGroupAssets = function () {
                return portalApiGateway.get("/WistiaApi/AffinityGroup");
            };

            service.getNextAssets = function () {
                return portalApiGateway.get("/WistiaApi/Next");
            };

            service.getMillenniumAssets = function () {
                return portalApiGateway.get("/WistiaApi/Millennium");
            };      

            service.getSurgeAssets = function () {
                return portalApiGateway.get("/WistiaApi/Surge");
            };   

            service.getElevateForLifeSchechterAssets = function () {
                return portalApiGateway.get("/WistiaApi/ElevateForLife/Schechter");
            };   

            service.getElevateForLifeLangdonAssets = function () {
                return portalApiGateway.get("/WistiaApi/ElevateForLife/Langdon");
            };    

            service.getCarAssets = function () {
                return portalApiGateway.get("/WistiaApi/Car");
            };  

            service.getHegnaAssets = function () {
                return portalApiGateway.get("/WistiaApi/Hegna");
            };  
            
            return service;
        }];
    }]);
})(window.app); // jshint ignore:line